import { Stack } from '@mui/material';
import React from 'react';

const SurveyContainer = ({ children }) => {
  return (
    <React.Fragment>
      <div
        style={{
          userSelect: 'none',
          backgroundColor: 'white',
          borderRadius: '20px',
        }}
      >
        <Stack gap=".5em" alignItems="center">
          {children}
        </Stack>
      </div>
    </React.Fragment>
  );
};

export default SurveyContainer;
